import React, { useEffect, useState, useContext, useRef } from "react";
import moment from "moment";
import { InputLabel } from "@mui/material";
import { Card, CardBody, Col, Row } from "reactstrap";

import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { isFilterApplied } from "./constant";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { constants } from "../../common/constant";
import { initialFilterForm, searchInitialFilterForm } from "./constant";

// import { FILTER_MENU, ReceiptListContext } from "./context";
const FilterMenu = ({
  paymentCategoryDropdown,
  processTagDropdown,
  rolesDropdown,
  filterCount,
  setFilterCount,
  closeForm,
  globalFilter,
  applyFilters,
}) => {
  const [filterForm, setFilterForm] = useState({ ...globalFilter, ...searchInitialFilterForm })
  const filterFormHandler = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }))
  }
  useEffect(() => setFilterForm(globalFilter), [])
  const handleApplyFilter = () => {
    closeForm();
    const filterCount = isFilterApplied({
      ...filterForm,
      ...searchInitialFilterForm,
      searchField: ''
    });
    setFilterCount(filterCount);

    applyFilters(filterForm);
  };
  const resetFilterForm = () => {
    closeForm();
    setFilterForm(initialFilterForm);
    applyFilters(initialFilterForm);
    setFilterCount(0);
  };
  const checkFilter=()=>{
    return isFilterApplied({
      ...filterForm,
      ...searchInitialFilterForm,
      searchField: ''
    })==0;
  }

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg mb-2">Filters</div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            label="Process Type"
            placeholder="Select to add"
            items={processTagDropdown}
            currentValue={filterForm?.processTag}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler('processTag', value)
            }}
            inputKey=""
          />
          <AAutoComplete
            label="Roles"
            placeholder="Select to add"
            items={rolesDropdown}
            currentValue={filterForm?.roles}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler('roles', value)
            }}
            inputKey=""
          />
          <AAutoComplete
            label="Payment Category"
            placeholder="Select to add"
            items={paymentCategoryDropdown}
            currentValue={filterForm?.paymentCategory}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler('paymentCategory', value)
            }}
            inputKey=""
          />
          <AAutoComplete
            label="Payment Type"
            placeholder="Select to add"
            items={constants.paymentType}
            currentValue={filterForm?.paymentType}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler('paymentType', value)
            }}
            inputKey=""
          />
          <div className={'mt-3 d-flex flex-row-reverse justify-content-between'}>

            <AButton
              variant="primary_filled"
              className="w-full"
              onClick={() => { handleApplyFilter() }}
              disabled={checkFilter()}
              updatedStyle={filterCount > 0 ? '' : { width: '100%' }}
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={() => { resetFilterForm() }}
              >
                Remove filter
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default FilterMenu;
